import axios from "axios";
import { BASE_URL } from "../index";

export const loginUser = async (serviceNumber) => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetUserDetails?serviceNumber=${serviceNumber}`
    );
    return response.data;
}